import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LanguajeService } from './languaje.service';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { StorageService } from './shared/storage.service';


@Injectable({
  providedIn: 'root'
})
export class TokenExpiredService {

  constructor(
    private alertController: AlertController,
    private translateService: TranslateService,
    private languajeService:LanguajeService,
    private storageService: StorageService,
		private router: Router,
		private authS: AuthService,
  ) {
   }

  async guardTokenExpired(){
    const isUserLoggedIn = await this.storageService.get('isUserLoggedIn');
    const token = await this.storageService.get('token');
      if (token) {
        if (this.tokenExpired(token)) {
          this.storageService.set('isUserLoggedIn', false);
          this.authS.logOutByToken();
          this.router.navigateByUrl('/login');
          return false;
        }
        else {  
          if (isUserLoggedIn) {
            return true;
          } else {
            this.authS.logOut();
            this.router.navigateByUrl('/login');
            return false;
          }
        }
      } else {
        this.router.navigateByUrl('/login');
        return false;
      }
    
  }

  tokenExpired(token: string) {
		const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    const tokenExp:boolean = (Math.floor((new Date).getTime() / 1000)) >= expiry;
    if(tokenExp){
      this.presentAlert();
    }
		return tokenExp;
  }
  
  async presentAlert() {
    this.languajeService.languaje.subscribe(l => {
      this.translateService.use(l);
    })
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: this.translateService.instant('ALERTA SESION'),
      message: this.translateService.instant('CADUCO SESION'),
      buttons: ['OK']
    });

    await alert.present();
  }
}
